let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("67Fw9")).then(() => parcelRequire('iK3VB'));